import apiClient from '../utils/apiClient';

const buildAuthHeaders = (token, extraHeaders = {}) => ({
  Authorization: `Bearer ${token}`,
  ...extraHeaders,
});

const getAuthConfig = (token, extraHeaders = {}) => ({
  headers: buildAuthHeaders(token, extraHeaders),
});

export const fetchAdminUserById = (token, userId) => {
  return apiClient.get(
    `/admin/${userId}`,
    getAuthConfig(token, { 'Accept-Encoding': 'identity' })
  );
};

export const fetchAdminHacs = (token) => {
  return apiClient.get('/admin/hacs', getAuthConfig(token, { 'Cache-Control': 'no-cache' }));
};

export const fetchAdminPmas = (token) => {
  return apiClient.get('/admin/pmas', getAuthConfig(token, { 'Cache-Control': 'no-cache' }));
};

export const deleteNominee = (token, hacId) =>
  apiClient.delete(`/hac/nominated/${hacId}`, getAuthConfig(token));
